import { authActions } from './auth-slice';
import { checkSession, updateUser, saveFilter, editFilter, deleteFilter, getFilters, login, extendSession } from '@/services/userService';
import { createCookie, deleteCookie, getCookie } from '@/utils/cookies/functions';

export const doLogIn = async (dispatch, username, password) => {
  try {
    dispatch(authActions.setLoading(true));
    dispatch(authActions.cleanErrors());
    const response = await login(username, password);
       
        if (response.result.token) {
          
          const token = response.result.token;
          const user = response.result.user;
          console.log('token:', token);

          // Set cookie and dispatch user details
          createCookie('Bearer', token, 0.3);
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('name', user.name);
          localStorage.setItem('id', user.username);
          localStorage.setItem('role', user.role);
          localStorage.setItem('token', token);
          localStorage.setItem('timeout', response.result.validUntil);
          dispatch(authActions.setUser(user));

          return {
            token: token,
            user: user.name,
          };
        } else {
          throw new Error('Invalid email or password');
        }
    } catch (error) {
      dispatch(authActions.setError(error));
      // Return the error so the caller (LoginPage) can distinguish a real
      // auth failure (401) from a network/server problem (e.g. 501 BFF_DOWN
      // when the API Gateway blocks the IP and there's no response at all).
      return { error };
    } finally {
      dispatch(authActions.setLoading(false));
    }
};

export const doUpdateUser = async (dispatch, id, updatedFields) => {
  try {
    dispatch(authActions.setLoading(true));
    const response = await updateUser(id, updatedFields);
    createCookie('Bearer', response.result, 0.3);
    // dispatch(authActions.setUser(response.result));
    return response;
  } catch (error) {
    dispatch(authActions.setError(error));
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doLogOut = async (dispatch, email, password) => {
  try {
    dispatch(authActions.setLoading(true));
    localStorage.removeItem('isLoggedIn'); // Clean up if session expired
    deleteCookie('Bearer');
    dispatch(authActions.cleanErrors());
    dispatch(authActions.logout());
  } catch (error) {
    dispatch(authActions.setError(error));
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doCheckSession = async dispatch => {

  const token = getCookie('Bearer'); // Retrieve token from cookies
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  if (token && isLoggedIn) {
    dispatch(authActions.setIsLoggedIn(true)); // Update Redux state
  } else {
    dispatch(authActions.setIsLoggedIn(false));
    localStorage.removeItem('isLoggedIn'); // Clean up if session expired
    deleteCookie('Bearer');
  }

  try {
    dispatch(authActions.setLoading(true));
    const response = await checkSession();
    console.log('response:', response);
    dispatch(authActions.cleanErrors());
    dispatch(authActions.setUser(response.result));
    
    // Update the timeout in both Redux store and localStorage
    if (response.result.timeout) {
      dispatch(authActions.setTimeout(response.result.timeout));
      localStorage.setItem('timeout', response.result.timeout);
    }
    
  } catch (error) {
    console.log('Session check failed, logging out:', error);
    // Clear stale session so the user is sent to login instead of seeing empty pages
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('name');
    localStorage.removeItem('id');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('timeout');
    deleteCookie('Bearer');
    dispatch(authActions.logout());
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doSaveFilter = async (dispatch, userId, name, filter) => {
  try {
    dispatch(authActions.setLoading(true));
    const response = await saveFilter(userId, name, filter);
    dispatch(authActions.saveFilter(response.result));
  } catch (error) {
    dispatch(authActions.setError(error));
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doEditFilter = async (dispatch, userId, previousName, updatedName, filter) => {
  try {
    dispatch(authActions.setLoading(true));
    const response = await editFilter(userId, previousName, updatedName, filter);
    dispatch(authActions.editFilter(response.result));
  } catch (error) {
    dispatch(authActions.setError(error));
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doDeleteFilter = async (dispatch, userId, name) => {
  try {
    dispatch(authActions.setLoading(true));
    const response = await deleteFilter(userId, name);
    dispatch(authActions.deleteFilter(response.result));
  } catch (error) {
    dispatch(authActions.setError(error));
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doGetFilters = async (dispatch, userId) => {
  try {
    dispatch(authActions.setLoading(true));
    const response = await getFilters(userId);
    dispatch(authActions.setFilters(response.result));
  } catch (error) {
    dispatch(authActions.setError(error));
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const doExtendSession = async dispatch => {
  try {
    dispatch(authActions.setLoading(true));
    dispatch(authActions.cleanErrors());
    const response = await extendSession();
    
    if (response && response.result) {
      const { token, validUntil } = response.result;
      
      // Update token and timeout in localStorage and Redux
      localStorage.setItem('token', token);
      localStorage.setItem('timeout', validUntil);
      createCookie('Bearer', token, 0.3);
      
      // Update timeout in Redux store
      dispatch(authActions.setTimeout(validUntil));
      
      return {
        success: true,
        token,
        validUntil
      };
    }
    
    return { success: false };
  } catch (error) {
    console.log('error extending session:', error);
    dispatch(authActions.setError(error));
    return { success: false, error };
  } finally {
    dispatch(authActions.setLoading(false));
  }
};

export const cleanErrors = dispatch => {
  dispatch(authActions.cleanErrors());
};

export const cleanstate = dispatch => {
  dispatch(authActions.cleanState());
};
